import Combine from './Combine/Combine';

import request from '../../Helpers/Request';

class Profiles {
    constructor(settings) {
        this.settings = settings;

        this.combine = new Combine(this.settings);
    }

    index() {
        return new Promise((resolve, reject) => {
            request('GET', '/profiles/admin', this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    destroy(id) {
        return new Promise((resolve, reject) => {
            request('DELETE', `/profiles/admin/${id}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Profiles;
